<template>
    <div class="canvas_layout">
      <canvas id="canvas"></canvas>
      <el-button @click="clearRect">クリア</el-button>
      <el-button type="primary" @click="updateImageData">保存する</el-button>
    </div>
</template>
  
<script>
export default {
    name: 'MaskImage',
    props: {
        imageUrl: {
            type: String,
            default: ''
        },
        paramImageWidth: {
            type: Number,
            default: 0
        },
        paramImageHeight: {
            type: Number,
            default: 0
        },
        isClearRect: {
            type: Boolean,
            default: false
        }
    },
    data:() => {
      return {
        drawing: false,
        imageWidth: 0,
        imageHeight: 0,
        offsetX: 0,
        offsetY: 0,
      }
    },
  
    methods:{
  
      // 初回マウント
      init(imageWidth, imageHeight){
        const canvas = document.getElementById('canvas');
        const ctx = canvas.getContext('2d');
        const image = new Image();
        image.crossOrigin = "Anonymous";
        image.src = this.imageUrl;
        image.width = imageWidth
        image.height = imageHeight
  
        image.onload = () => {
          // canvasのサイズを画像と同サイズに設定
          canvas.width = image.width
          canvas.height = image.height
          // 画像のサイズがcanvasを超える場合はアスペクト比を合わせてcanvas内に治るように調整
          const { drawWidth, drawHeight } = this.calculateImageSize(image.width, image.height, canvas.width, canvas.height);
          const x = (canvas.width - drawWidth) / 2;
          const y = (canvas.height - drawHeight) / 2;
          ctx.drawImage(image, x, y, drawWidth, drawHeight);
  
          // マスク図形の描画開始
          canvas.onmousedown = (event) => {
            this.drawing = true
            this.offsetX = event.offsetX
            this.offsetY = event.offsetY
            ctx.strokeStyle = 'red';
            ctx.beginPath();
            if (!event.pointer) return;
          }
          // マスク図形の描画中
          canvas.onmousemove = (event) => {
            if(this.drawing) {
              ctx.fillRect(this.offsetX, this.offsetY, event.offsetX - this.offsetX, event.offsetY - this.offsetY);
              if (!event.pointer) return;
            }
          }
          // マスク図形の描画終了
          canvas.onmouseup = (event) => {
            this.drawing = false;
            ctx.closePath();
            // ctx.fillRect(this.offsetX, this.offsetY, event.offsetX - this.offsetX, event.offsetY - this.offsetY);
            this.offsetX = 0;
            this.offsetY = 0;
          }
        };
      },
      adjustSizeByWidth(canvasWidth, imageAspectRatio, scale) {
        const drawWidth = canvasWidth * scale;
        const drawHeight = drawWidth / imageAspectRatio;
        return { drawWidth, drawHeight };
      },
      adjustSizeByHeight(canvasHeight, imageAspectRatio, scale) {
        const drawHeight = canvasHeight * scale;
        const drawWidth = drawHeight * imageAspectRatio;
        return { drawWidth, drawHeight };
      },
      calculateImageSize(imageWidth, imageHeight, canvasWidth, canvasHeight, scale = 1.0) {
        const imageAspectRatio = imageWidth / imageHeight;
        const canvasAspectRatio = canvasWidth / canvasHeight;
        // 画像のアスペクト比が1:1の場合
        if(imageAspectRatio === 1) {
          if(imageHeight > canvasHeight) {
            // 画像の方がcanvasより大きい場合はcanvasのサイズに収まるように調整
            return this.adjustSizeByHeight(canvasHeight, imageAspectRatio, scale);
          }
          // 画像のサイズをそのまま表示
          return this.adjustSizeByHeight(imageHeight, imageAspectRatio, scale);
        } else {
          if (imageAspectRatio > canvasAspectRatio && imageWidth > canvasWidth) {
            // 画像の方がcanvasより大きい場合はcanvasのサイズに収まるように調整
            return this.adjustSizeByWidth(canvasWidth, imageAspectRatio, scale);
          } else if(imageHeight > canvasHeight) {
            // 画像の方がcanvasより大きい場合はcanvasのサイズに収まるように調整
            return this.adjustSizeByHeight(canvasHeight, imageAspectRatio, scale);
          } else {
            // 画像のサイズをそのまま表示
            return this.adjustSizeByHeight(imageHeight, imageAspectRatio, scale);
          }
        }
      },
      /**
       * マスクした図形を全て消去
       */
      clearRect() {
        const canvas = document.getElementById('canvas');
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.init(this.imageWidth, this.imageHeight);
      },
      updateImageData() {
        if(window.confirm('画像の編集を保存しますか？保存してしまうと取り消しができません。')) {
            const canvas = document.getElementById('canvas');
            this.$emit('emitUpdateImage', canvas.toDataURL().replace('data:image/png;base64,', ''));
        }
      }
    },
    mounted(){
      this.init(this.paramImageWidth, this.paramImageHeight);
      this.imageWidth = this.paramImageWidth
      this.imageHeight = this.paramImageHeight
      this.$watch(() => this.isClearRect, () => {
        if(this.isClearRect) this.clearRect()
      })
    }
}
</script>
<style lang="scss" scoped>
.canvas_layout {
    width: 100%;
    height: 100%;
}
</style>